<div class="auth-wrapper">
  <div class="testimonial-div">
    <div class="my-4">
      <h3 class="text-gray lh-50">
        join other businesses who enjoy <br />
        <b>cheaper FX rates, faster settlement periods &amp; liquidity</b>
      </h3>
    </div>
    <div class="my-4">
      <div class="d-flex align-items-center mb-5">
        <img
          src="assets/images/password.svg"
          alt="password"
          class="flash-icon" />
        <div class="ms-4">
          <p class="h5 text-gray mb-0"><b>reset</b> your <b>password</b></p>
          <p class="text-gray mb-0">
            please enter your
            <!-- XBP -->
            email address, we will send the password reset instructions to the
            email address for this account.
          </p>
        </div>
      </div>
      <div class="d-flex align-items-center mb-5">
        <img src="assets/images/mail.svg" alt="mail" class="flash-icon" />
        <div class="ms-4">
          <p class="h5 text-gray mb-0"><b>lost</b> your email id?</p>
          <p class="text-gray mb-0">
            please contact us on
            <a href="mailto:platform@xbp.com" class="auth-hyperlink">
              XBP Support
            </a>
            for further assistance.
          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="form-div">
    <img src="" class="logo mb-5" alt="" />
    <p class="text-gray h3 mb-4">
      <b>Forgot</b> your
      <!-- XBP -->
      <b>password</b>?
    </p>
    <p class="text-gray my-4">
      Please enter your
      <!-- XBP -->
      email address, we will send the password reset instructions to the email
      address for this account.
    </p>
    <form
      [formGroup]="forgotPasswordForm"
      (ngSubmit)="onSubmit()"
      autocomplete="off">
      <app-auth-input
        [inputData]="attributeConstant.email"
        [formControlName]="attributeConstant.email.key">
      </app-auth-input>
      <button class="btn primary-btn w-100">Reset my password</button>
    </form>
    <h6 class="text-navy mt-1-875">
      Remembered your password?
      <a routerLink="/auth/login" class="auth-hyperlink">Sign in</a>
    </h6>
  </div>
</div>
